import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

/** GET /penalty?pks_id=&mitra_id=&penalty_type=&payment_status=&page=&limit= */
export async function getPenalties(queryParams = "", extraHeaders = {}) {
  return await instance({ baseURL }).get("/penalty" + queryParams, {
    headers: extraHeaders,
  });
}

/** GET /penalty/:id */
export async function getPenaltyById(id) {
  return await instance({ baseURL }).get(`/penalty/${id}`);
}

/** GET /penalty/pks/:pks_id */
export async function getPenaltiesByPKS(pks_id) {
  return await instance({ baseURL }).get(`/penalty/pks/${pks_id}`);
}

/** GET /penalty/mitra/:mitra_id */
export async function getPenaltiesByMitra(mitra_id) {
  return await instance({ baseURL }).get(`/penalty/mitra/${mitra_id}`);
}

/** GET /penalty/overdue */
export async function getOverduePenalties() {
  return await instance({ baseURL }).get("/penalty/overdue");
}

/** POST /penalty */
export async function createPenalty(body) {
  return await instance({ baseURL }).post("/penalty", body);
}

/** POST /penalty/from-invoice/:invoice_id */
export async function createPenaltyFromInvoice(invoice_id) {
  return await instance({ baseURL }).post(`/penalty/from-invoice/${invoice_id}`);
}

/** PUT /penalty/:id */
export async function updatePenalty(id, body) {
  return await instance({ baseURL }).put(`/penalty/${id}`, body);
}

/** DELETE /penalty/:id */
export async function deletePenalty(id) {
  return await instance({ baseURL }).delete(`/penalty/${id}`);
}

/** POST /penalty/:id/issue */
export async function issuePenalty(id) {
  return await instance({ baseURL }).post(`/penalty/${id}/issue`);
}

/** POST /penalty/:id/payment */
export async function recordPenaltyPayment(id, body) {
  return await instance({ baseURL }).post(`/penalty/${id}/payment`, body);
}

/** POST /penalty/:id/waive */
export async function waivePenalty(id, body) {
  return await instance({ baseURL }).post(`/penalty/${id}/waive`, body);
}

/** POST /penalty/:id/dispute */
export async function disputePenalty(id, body) {
  return await instance({ baseURL }).post(`/penalty/${id}/dispute`, body);
}

/** POST /penalty/:id/resolve-dispute */
export async function resolveDisputePenalty(id, body) {
  return await instance({ baseURL }).post(`/penalty/${id}/resolve-dispute`, body);
}
